/**
 * 組織状況タイプ
 */
export var OrganizationStatusTypes;

(function (OrganizationStatusTypes) {
  /**
   * 契約中
   */
  OrganizationStatusTypes[OrganizationStatusTypes["UnderContract"] = 0] = "UnderContract";
  /**
   * 停止中
   */

  OrganizationStatusTypes[OrganizationStatusTypes["Deleted"] = 1] = "Deleted";
  /**
   * 中断中
   */

  OrganizationStatusTypes[OrganizationStatusTypes["Suspended"] = 2] = "Suspended";
  /**
   * 契約なし
   */

  OrganizationStatusTypes[OrganizationStatusTypes["NoContract"] = 3] = "NoContract";
  /**
   * トライアル中
   */

  OrganizationStatusTypes[OrganizationStatusTypes["Trial"] = 4] = "Trial";
  /**
   * 契約予定
   */

  OrganizationStatusTypes[OrganizationStatusTypes["ScheduleContract"] = 5] = "ScheduleContract";
})(OrganizationStatusTypes || (OrganizationStatusTypes = {}));